<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-[9999] flex items-center justify-center p-4 overflow-y-auto"
  >
    <!-- Backdrop -->
    <div
      class="absolute inset-0 bg-background/80 backdrop-blur-sm"
      @click="onClose"
    ></div>

    <!-- Modal Card -->
    <div
      class="relative bg-card w-[680px] max-w-[95vw] max-h-[90vh] rounded-xl shadow-xl border border-border flex flex-col"
    >
      <div
        class="flex items-center justify-between p-6 pb-4 border-b border-border flex-shrink-0"
      >
        <h3 class="text-[18px] font-semibold text-foreground">
          {{ hub?.id ? "Edit Hub" : "Create Hub" }}
        </h3>
        <button
          class="p-2 rounded hover:bg-muted"
          @click="onClose"
          aria-label="Close"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path
              d="M6 6l12 12M6 18L18 6"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>

      <div class="overflow-y-auto flex-1 px-6 py-4">
        <div class="grid grid-cols-2 gap-4">
          <div class="col-span-2">
            <label class="block text-[14px] text-muted-foreground mb-1"
              >Hub Name *</label
            >
            <input
              v-model="form.name"
              type="text"
              class="w-full bg-card border border-border rounded-lg px-3 py-2 text-[14px] text-foreground placeholder:text-muted-foreground/50"
              placeholder="Workspace name"
            />
          </div>
          <div class="col-span-2">
            <label class="block text-[14px] text-muted-foreground mb-1"
              >Description</label
            >
            <textarea
              v-model="form.description"
              rows="3"
              class="w-full bg-card border border-border rounded-lg px-3 py-2 text-[14px] text-foreground placeholder:text-muted-foreground/50"
              placeholder="Short description"
            ></textarea>
          </div>
          <div class="col-span-2">
            <label class="block text-[14px] text-muted-foreground mb-1"
              >Address</label
            >
            <input
              v-model="form.address"
              type="text"
              class="w-full bg-card border border-border rounded-lg px-3 py-2 text-[14px] text-foreground placeholder:text-muted-foreground/50"
              placeholder="Street, City"
            />
          </div>
          <div>
            <label class="block text-[14px] text-muted-foreground mb-1"
              >Latitude</label
            >
            <input
              v-model.number="form.latitude"
              type="number"
              step="0.000001"
              class="w-full bg-card border border-border rounded-lg px-3 py-2 text-[14px] text-foreground"
            />
          </div>
          <div>
            <label class="block text-[14px] text-muted-foreground mb-1"
              >Longitude</label
            >
            <input
              v-model.number="form.longitude"
              type="number"
              step="0.000001"
              class="w-full bg-card border border-border rounded-lg px-3 py-2 text-[14px] text-foreground"
            />
          </div>
          <div>
            <label class="block text-[14px] text-muted-foreground mb-1"
              >Website</label
            >
            <input
              v-model="form.website"
              type="url"
              class="w-full bg-card border border-border rounded-lg px-3 py-2 text-[14px] text-foreground placeholder:text-muted-foreground/50"
              placeholder="https://"
            />
          </div>
          <!-- <div>
          <label class="block text-[12px] text-gray-600 mb-1">Image URL</label>
          <input v-model="form.image_url" type="url" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-[13px]" placeholder="https://" />
        </div> -->
          <div>
            <label class="block text-[14px] text-muted-foreground mb-1"
              >Capacity</label
            >
            <input
              v-model.number="form.capacity"
              type="number"
              min="0"
              class="w-full bg-card border border-border rounded-lg px-3 py-2 text-[14px] text-foreground"
            />
          </div>
          <div class="col-span-2">
            <label class="block text-[14px] text-muted-foreground mb-1"
              >Amenities (comma separated)</label
            >
            <input
              v-model="amenitiesInput"
              type="text"
              class="w-full bg-card border border-border rounded-lg px-3 py-2 text-[14px] text-foreground placeholder:text-muted-foreground/50"
              placeholder="WiFi, 24/7 Power, Whiteboard"
            />
          </div>
          <div class="col-span-2 flex items-center gap-6">
            <label class="flex items-center gap-2">
              <input v-model="form.is_public" type="checkbox" class="w-4 h-4" />
              <span class="text-[14px] text-foreground">Public</span>
            </label>
            <label class="flex items-center gap-2">
              <input v-model="form.is_free" type="checkbox" class="w-4 h-4" />
              <span class="text-[14px] text-foreground">Is Free</span>
            </label>
          </div>
          <div v-if="!form.is_free">
            <label class="block text-[14px] text-muted-foreground mb-1"
              >Currency</label
            >
            <input
              v-model="form.currency"
              type="text"
              class="w-full bg-card border border-border rounded-lg px-3 py-2 text-[14px] text-foreground"
              placeholder="NGN"
            />
          </div>
          <div v-if="!form.is_free">
            <label class="block text-[14px] text-muted-foreground mb-1"
              >Price Per Hour</label
            >
            <input
              v-model.number="form.price_per_hour"
              type="number"
              min="0"
              step="0.01"
              class="w-full bg-card border border-border rounded-lg px-3 py-2 text-[14px] text-foreground"
            />
          </div>
          <div v-if="!form.is_free">
            <label class="block text-[14px] text-muted-foreground mb-1"
              >Price Per Day</label
            >
            <input
              v-model.number="form.price_per_day"
              type="number"
              min="0"
              step="0.01"
              class="w-full bg-card border border-border rounded-lg px-3 py-2 text-[14px] text-foreground"
            />
          </div>
          <div v-if="!form.is_free">
            <label class="block text-[14px] text-muted-foreground mb-1"
              >Price Per Month</label
            >
            <input
              v-model.number="form.price_per_month"
              type="number"
              min="0"
              step="0.01"
              class="w-full bg-card border border-border rounded-lg px-3 py-2 text-[14px] text-foreground"
            />
          </div>
          <div v-if="!form.is_free" class="col-span-2">
            <label class="block text-[14px] text-muted-foreground mb-1"
              >Pricing Notes</label
            >
            <textarea
              v-model="form.pricing_notes"
              rows="2"
              class="w-full bg-card border border-border rounded-lg px-3 py-2 text-[14px] text-foreground"
            ></textarea>
          </div>
          <div class="col-span-2">
            <label class="block text-[14px] text-muted-foreground mb-2"
              >Operating Hours</label
            >
            <div class="space-y-2">
              <div
                v-for="day in daysOfWeek"
                :key="day"
                class="flex items-center gap-3"
              >
                <span class="w-24 text-[14px] text-foreground capitalize">{{
                  day
                }}</span>
                <input
                  v-model="operatingHours[day].open"
                  type="time"
                  class="flex-1 bg-card border border-border rounded-lg px-3 py-1.5 text-[14px] text-foreground"
                />
                <span class="text-[14px] text-muted-foreground">to</span>
                <input
                  v-model="operatingHours[day].close"
                  type="time"
                  class="flex-1 bg-card border border-border rounded-lg px-3 py-1.5 text-[14px] text-foreground"
                />
                <label class="flex items-center gap-1.5">
                  <input
                    v-model="operatingHours[day].closed"
                    type="checkbox"
                    class="w-4 h-4"
                  />
                  <span class="text-[14px] text-muted-foreground">Closed</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="border-t border-border p-6 pt-4 flex items-center justify-end gap-3 flex-shrink-0"
      >
        <button
          class="px-4 py-2 border border-border rounded-full text-[14px] text-foreground hover:bg-muted"
          @click="onClose"
        >
          Cancel
        </button>
        <button
          :disabled="submitting || !canSubmit"
          class="px-4 py-2 bg-foreground text-background rounded-full text-[14px] disabled:opacity-50 font-medium"
          @click="submit"
        >
          {{ hub?.id ? "Update Hub" : "Create" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from "@/axios";
export default {
  name: "WorkspaceCreateModal",
  props: {
    isOpen: { type: Boolean, default: false },
    hub: { type: Object, default: null },
  },
  emits: ["close", "created", "updated"],
  data() {
    return {
      submitting: false,
      amenitiesInput: "",
      daysOfWeek: [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday",
      ],
      operatingHours: {
        monday: { open: "08:00", close: "18:00", closed: false },
        tuesday: { open: "08:00", close: "18:00", closed: false },
        wednesday: { open: "08:00", close: "18:00", closed: false },
        thursday: { open: "08:00", close: "18:00", closed: false },
        friday: { open: "08:00", close: "18:00", closed: false },
        saturday: { open: "09:00", close: "17:00", closed: false },
        sunday: { open: "09:00", close: "17:00", closed: true },
      },
      form: {
        name: "",
        description: "",
        address: "",
        latitude: null,
        longitude: null,
        project_id: null,
        is_public: true,
        capacity: null,
        amenities: [],
        contact_info: null,
        operating_hours: null,
        image_url: "",
        website: "",
        price_per_hour: null,
        price_per_day: null,
        price_per_month: null,
        currency: "NGN",
        pricing_notes: "",
        is_free: false,
      },
    };
  },
  computed: {
    canSubmit() {
      return !!this.form.name && !this.submitting;
    },
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.initForm();
      }
    },
  },
  methods: {
    onClose() {
      if (this.submitting) return;
      this.$emit("close");
    },
    initForm() {
      if (this.hub) {
        // Populate form with existing hub data
        Object.keys(this.form).forEach((key) => {
          if (this.hub[key] !== undefined) {
            this.form[key] = this.hub[key];
          }
        });

        // Handle amenities
        if (this.hub.amenities) {
          this.amenitiesInput = Array.isArray(this.hub.amenities)
            ? this.hub.amenities.join(", ")
            : this.hub.amenities;
        }

        // Handle operating hours
        if (this.hub.operating_hours) {
          const hours = this.hub.operating_hours;
          this.daysOfWeek.forEach((day) => {
            const dayData = hours[day] || hours[day.toLowerCase()];
            if (dayData === "closed") {
              this.operatingHours[day].closed = true;
            } else if (dayData && dayData.includes("-")) {
              const [open, close] = dayData.split("-");
              this.operatingHours[day].open = open;
              this.operatingHours[day].close = close;
              this.operatingHours[day].closed = false;
            }
          });
        }
      } else {
        // Reset form for creation
        this.form = {
          name: "",
          description: "",
          address: "",
          latitude: null,
          longitude: null,
          project_id: null,
          is_public: true,
          capacity: null,
          amenities: [],
          contact_info: null,
          operating_hours: null,
          image_url: "",
          website: "",
          price_per_hour: null,
          price_per_day: null,
          price_per_month: null,
          currency: "NGN",
          pricing_notes: "",
          is_free: false,
        };
        this.amenitiesInput = "";
        this.operatingHours = {
          monday: { open: "08:00", close: "18:00", closed: false },
          tuesday: { open: "08:00", close: "18:00", closed: false },
          wednesday: { open: "08:00", close: "18:00", closed: false },
          thursday: { open: "08:00", close: "18:00", closed: false },
          friday: { open: "08:00", close: "18:00", closed: false },
          saturday: { open: "09:00", close: "17:00", closed: false },
          sunday: { open: "09:00", close: "17:00", closed: true },
        };
      }
    },
    buildPayload() {
      const payload = { ...this.form };
      // Parse amenities
      if (this.amenitiesInput && typeof this.amenitiesInput === "string") {
        payload.amenities = this.amenitiesInput
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean);
      }
      const hours = {};
      this.daysOfWeek.forEach((day) => {
        const dayData = this.operatingHours[day];
        if (dayData.closed) {
          hours[day] = "closed";
        } else if (dayData.open && dayData.close) {
          hours[day] = `${dayData.open}-${dayData.close}`;
        }
      });
      payload.operating_hours = Object.keys(hours).length ? hours : null;
      return payload;
    },
    async submit() {
      if (!this.canSubmit) return;
      this.submitting = true;
      try {
        const payload = this.buildPayload();
        if (this.hub?.id) {
          const res = await apiClient.put(
            `/web/workspace/${this.hub.id}`,
            payload,
          );
          this.$emit("updated", res.data?.data || payload);
        } else {
          const res = await apiClient.post("/web/workspace", payload);
          const created = (res.data && res.data.data) || null;
          this.$emit("created", created || payload);
        }
      } catch (e) {
        console.error("Failed to save workspace", e);
        alert(
          e?.response?.data?.detail || e?.message || "Failed to save workspace",
        );
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped></style>
